import { render } from "./weight-kg.vue?vue&type=template&id=1a1f9724&ts=true"
import script from "./weight-kg.vue?vue&type=script&lang=ts"
export * from "./weight-kg.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__